import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon } from '@/components';
import { RootStore } from '@/models';
import ActionBtn from '../ActionBtn';
import styles from './index.less';
import classNames from 'classnames';

interface Props extends Partial<Pick<RootStore, 'rtc' | 'chat' | 'meeting'>> {
  RTCInstance?: RootStore['rtc'];
  chat?: RootStore['chat'];
  meeting?: RootStore['meeting'];
  popoverVisible?: boolean;
  onClick?: (e: Event) => void;
  className?: string;
}

const ChatBtn: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    chat: store.chat,
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { RTCInstance, chat, popoverVisible, onClick, className } = props;
    const { formatMessage } = useIntl();
    const [isChatTooltipVisible, setIsChatTooltipVisible] = React.useState(false);

    const onChatTooltipChange = React.useCallback(
      (visible) => {
        if (!popoverVisible || !visible) {
          setIsChatTooltipVisible(visible);
        }
      },
      [isChatTooltipVisible, popoverVisible]
    );

    return (
      <ActionBtn
        tooltipConfig={{
          visible: isChatTooltipVisible,
          onVisibleChange: onChatTooltipChange,
        }}
        title={formatMessage({ id: 'CHAT' })}
        bottomTitle={formatMessage({ id: 'CHAT' })}
        className={classNames(styles['chatBtn'], className, {
          [styles['has-red-dot']]: chat?.unReadMsg && chat?.isAbleUse,
          [styles.on]: chat?.chatVisible,
          [styles.disable]: !chat?.isAbleUse || RTCInstance?.breakLineReconnecting,
        })}
        onClick={(e) => {
          onClick && onClick(e);
        }}
      >
        <Icon className={styles.icon} name="icon-message_solid1" />
      </ActionBtn>
    );
  })
);

export default ChatBtn;
